import { render } from "./NewThreadList.vue?vue&type=template&id=a78f7044"
import script from "./NewThreadList.vue?vue&type=script&lang=js"
export * from "./NewThreadList.vue?vue&type=script&lang=js"

import "./NewThreadList.vue?vue&type=style&index=0&id=a78f7044&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__